const sourceOf = (image: HTMLImageElement) => image.currentSrc || image.src;

/**
 * Resolves once the image has loaded or given up. Ad previews retry a failed image against its raw URL, in the
 * error event or a render later, so a failure counts only once two frames pass with no new source loading.
 */
export function whenImageSettles(image: HTMLImageElement) {
  return new Promise<void>((resolve) => {
    const settle = () => {
      image.removeEventListener("load", settle);
      image.removeEventListener("error", onError);
      resolve();
    };
    const onError = () => {
      const failed = sourceOf(image);
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          if (
            !image.isConnected ||
            (image.complete && sourceOf(image) === failed)
          )
            settle();
        }),
      );
    };
    image.addEventListener("load", settle);
    image.addEventListener("error", onError);
  });
}
